<div class="platform-shell">
  <app-header></app-header>
  <div class="platform-body">
    <nav class="platform-navigation" aria-label="Navegação principal">
      @for (item of menu.getMenu(); track item.link) {
        <a [routerLink]="item.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">{{
          item.text
        }}</a>
      }
    </nav>
    <main class="platform-content"><router-outlet></router-outlet></main>
  </div>
  <footer class="platform-footer" app-footer></footer>
</div>
